"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERIFICATION_REQUIRED = exports.LIMITED_DIRECT_WITHDRAWAL = exports.LIMITED_RECOVERY = exports.LIMITED = exports.PARTIAL = exports.GUEST = exports.DELETED = exports.BANNED = exports.ACTIVE = void 0;
exports.ACTIVE = 'ACTIVE';
exports.BANNED = 'BANNED';
exports.DELETED = 'DELETED';
exports.GUEST = 'GUEST';
exports.PARTIAL = 'PARTIAL';
exports.LIMITED = 'LIMITED';
exports.LIMITED_RECOVERY = 'LIMITED_RECOVERY';
exports.LIMITED_DIRECT_WITHDRAWAL = 'LIMITED_DIRECT_WITHDRAWAL';
exports.VERIFICATION_REQUIRED = 'VERIFICATION_REQUIRED';
